import moment from "moment";
import { TarifarioRodoviario } from "../../index";
import { BloqueioTrechoRodoviario } from "./bloqueiotrechorodoviario.model";

export class BloqueioRodoviario {
    constructor() {
        this.ValidadeDe = moment(new Date());
        this.ValidadeAte = moment(new Date());
        this.DataPartida = moment(new Date());
        this.DataRetorno = moment(new Date());
    }

    Id: number = 0;
    TarifarioRodoviario: TarifarioRodoviario;
    TarifarioRodoviarioId: number;
    Localizador: string;
    DataPartida: moment.Moment;
    DataRetorno: moment.Moment;
    MinAntecedencia: number;
    Quantidade: number;
    Disponiveis: number;
    Reservados: number;
    ValidadeDe: moment.Moment;
    ValidadeAte: moment.Moment;
    Ativo: boolean;
    BloqueioTrechosRodoviario: BloqueioTrechoRodoviario[] = [];
}
